import { updateDataSource } from 'slices/appsReportSourceType';
import { useAppDispatch } from 'slices/store';
import { Switch } from '@timeedit/ui-components/antd';

type TConfigurationItem = {
  field?: any;
  title?: any;
  placeholder?: any;
  value?: any;
};
const ConfigurationItem = ({
  field,
  title,
  placeholder,
  value,
}: TConfigurationItem) => {
  const dispatch = useAppDispatch();

  const handleToggle = (value: boolean) => {
    dispatch(
      updateDataSource({
        [field]: value,
      })
    );
  };

  return (
    <div className="configuration-item">
      <span className="item-control">
        <Switch defaultChecked={value} onChange={handleToggle} />
      </span>
      <span className="item-description">
        <span className="title">{title}</span>
        <span className="placeholder">{placeholder}</span>
      </span>
    </div>
  );
};

export default ConfigurationItem;
